const fundStatistics = () =>
    import('@/modules/jrtj/fundStatistics/policyLoanList');
const loanCompanyStatistics = () =>
    import('@/modules/jrtj/fundStatistics/loanCompanyStatistics');
const loanIndustryStatistics = () =>
    import('@/modules/jrtj/fundStatistics/loanIndustryStatistics');
const loanAreaStatistics = () =>
    import('@/modules/jrtj/fundStatistics/loanAreaStatistics');
const loanProductStatistics = () =>
    import('@/modules/jrtj/fundStatistics/loanProductStatistics');
const bankFkMessage = () =>
    import('@/modules/jrtj/fundStatistics/bankFkMessageList');
const dhgl = () =>
    import('@/modules/jrtj/fundStatistics/dhglList');
const dhgldetail = () =>
    import('@/modules/jrtj/fundStatistics/dhglDetail');
const dhglOnlyUpState = () =>
    import('@/modules/jrtj/fundStatistics/dhglOnlyUpState');
const dhgldetailview = () =>
    import('@/modules/jrtj/fundStatistics/dhglDetailView');
const WprDetailList = () =>
    import('@/modules/jrtj/fundStatistics/WprDetail');
const EprDetailList = () =>
    import('@/modules/jrtj/fundStatistics/EnterpriseLoanDetail');
const HNCorporationDetail = () =>
    import('@/modules/jrtj/fundStatistics/hnCorporationDetail');

const bankFkhz = () =>
    import('@/modules/jrtj/fundStatistics/bankFkhzList');
const bankHk = () =>
    import('@/modules/jrtj/fundStatistics/bankHkList');
const orderCount = () =>
    import('@/modules/jrtj/fundStatistics/orderCountList');
const companyList = () =>
    import('@/modules/jrtj/fundStatistics/companyList');
const companyLoanDetail = () =>
    import('@/modules/jrtj/fundStatistics/CompanyLoanDetail');
const fundsummary = () =>
    import('@/modules/jrtj/fundsummary/FundSummaryList');
const zcdsummary = () =>
    import('@/modules/jrtj/zcdsummary/ZcdSummaryList');
const mpSjrSummary = () =>
    import('@/modules/jrtj/mpSjrSummary/MpSjrSummaryList');
const mpSjrApplyDetail = () =>
    import('@/modules/jrtj/mpSjrSummary/MpSjrApplyDetail');
const mpSjrLoanDetail = () =>
    import('@/modules/jrtj/mpSjrSummary/MpSjrLoanDetail');
const mpSjrOrderList = () =>
    import('@/modules/jrtj/mpSjrSummary/MpSjrOrderList');
const unPayOffTheLoanList = () =>
    import('@/modules/jrtj/fundStatistics/unPayOffTheLoanList');
const PageLoanProgressDetail = () =>
    import('@/modules/jrtj/fundsummary/PageLoanProgressDetail');
const PageLoanProgressDetailApplynumber = () =>
    import('@/modules/jrtj/fundsummary/PageLoanProgressDetailApplynumber');
const CreditList = () =>
    import('@/modules/jrtj/fundsummary/CreditList');

const PageLoanProgressDetailCreditnumber = () =>
    import('@/modules/jrtj/fundsummary/PageLoanProgressDetailCreditnumber');
const PageLoanProgressDetailLoannumber = () =>
    import('@/modules/jrtj/fundsummary/PageLoanProgressDetailLoannumber');
const PageRuKu = () =>
    import('@/modules/jrtj/fundStatistics/PageRuKu');
const PageHndRuKu = () =>
    import('@/modules/jrtj/fundStatistics/PageHndRuKu');
const PageCredit = () =>
    import('@/modules/jrtj/fundStatistics/PageCredit');
const PageLoaninfoDetail = () =>
    import('@/modules/jrtj/fundStatistics/PageLoaninfoDetail');
const PageBankLoanDetail = () =>
    import('@/modules/jrtj/fundStatistics/PageBankLoanDetail');
const pageAccpetanceEnterprise = () =>
    import('@/modules/jrtj/wprStatistics/PageAccpetanceEnterprise');
const pageAccpetanceNumber = () =>
    import('@/modules/jrtj/wprStatistics/PageAccpetanceNumber');
const searchXbcpLoan = () =>
    import('@/components/SearchXbcpLoan');
const searchXbcpLoanXQ = () =>
    import('@/modules/jrtj/xbcploan/SearchXbcpLoanXQ');
const cxdStatistics = () =>
    import('@/modules/jrtj/fundStatistics/cxdStatistics');
const XbjjTotalLoanData = () =>
    import('@/modules/jrtj/fundStatistics/XbjjTotalLoanData');
const xbjjSituation = () =>
    import('@/modules/jrtj/fundStatistics/xbjjSituation');
const cxdMDKList = () =>
    import('@/modules/cxsd/cxd/cxdMDKList');
const cxdtxPage = () =>
    import('@/modules/cxsd/cxd/cxdtxPage');
const cxdtxPageCS = () =>
    import('@/modules/cxsd/cxd/cxdtxPageCS');
const cxdtxPageSH = () =>
    import('@/modules/cxsd/cxd/cxdtxPageSH');
const cxdtxPageFH = () =>
    import('@/modules/cxsd/cxd/cxdtxPageFH');
const cxdtxPageView = () =>
    import('@/modules/cxsd/cxd/cxdtxPageView');
const bankAssessment = () =>
    import('@/modules/jrtj/fundStatistics/bankAssessment');

export default [{
  path: '/jrtj/xbcpdktj',
  name: 'fundStatistics',
  component: fundStatistics,
  meta: {
    title: '信保产品贷款统计',
    isBlack: true
  }
},
{
  path: '/jrtj/yhfkxxcx',
  name: 'bankFkMessage',
  component: bankFkMessage,
  meta: {
    title: '银行放款信息查询',
    isBlack: true
  }
},
{
  path: '/jrtj/dhgl',
  name: 'dhgl',
  component: dhgl,
  meta: {
    title: '贷后管理'
  }
},
{
  path: '/jrtj/dhgldetail',
  name: 'dhgldetail',
  component: dhgldetail,
  meta: {
    title: '贷后管理详细页'
  }
},
{
  path: '/jrtj/dhglOnlyUpState',
  name: 'dhglOnlyUpState',
  component: dhglOnlyUpState,
  meta: {
    title: '仅更新贷后管理状态'
  }
},
{
  path: '/jrtj/dhgldetailView',
  name: 'dhgldetailView',
  component: dhgldetailview,
  meta: {
    title: '贷后管理查看页'
  }
},
{
  path: '/jrtj/yhfkhzb',
  name: 'bankFkhz',
  component: bankFkhz,
  meta: {
    title: '银行放款汇总表',
    isBlack: true
  }
},
{
  path: '/jrtj/yhhktjb',
  name: 'bankHk',
  component: bankHk,
  meta: {
    title: '银行还款统计表',
    isBlack: true
  }
},
{
  path: '/jrtj/yhddlctjb',
  name: 'orderCount',
  component: orderCount,
  meta: {
    title: '银行订单流程统计表',
    isBlack: true
  }
},
{
  path: '/loanCompanyStatistics',
  name: 'loanCompanyStatistics',
  component: loanCompanyStatistics,
  meta: {
    title: '贷款分地区统计',
    isBlack: true
  }
},
{
  path: '/loanIndustryStatistics',
  name: 'loanIndustryStatistics',
  component: loanIndustryStatistics,
  meta: {
    title: '贷款分行业统计',
    isBlack: true
  }
},
{
  path: '/loanAreaStatistics',
  name: 'loanAreaStatistics',
  component: loanAreaStatistics,
  meta: {
    title: '贷款分地区统计',
    isBlack: true
  }
},
{
  path: '/loanProductStatistics',
  name: 'loanProductStatistics',
  component: loanProductStatistics,
  meta: {
    title: '贷款分产品统计',
    isBlack: true
  }
},
{
  path: '/companyLoanDetail',
  name: 'companyLoanDetail',
  component: companyLoanDetail,
  meta: {
    title: '企业贷款详细信息1',

  },
},
{
  path: '/loanAreaStatistics',
  name: 'loanAreaStatistics',
  component: loanAreaStatistics,
  meta: {
    title: '贷款分地区统计'
  }
},
{
  path: '/WprDetailList',
  name: 'WprDetailList',
  component: WprDetailList,
  meta: {
    title: '微票融情况汇总表'
  }
},
{
  path: '/EnterpriseLoanDetail',
  name: 'EprDetailList',
  component: EprDetailList,
  meta: {
    title: '企业贷款概况统计',
    isBlack: true
  }
},
{
  path: '/hnCorporationDetailList',
  name: 'HNCorporationDetail',
  component: HNCorporationDetail,
  meta: {
    title: '惠农贷统计'
  }
},

  // 企业贷款
{
  path: '/fundsummary',
  name: 'fundsummary',
  component: fundsummary,
  meta: {
    title: '信保产品贷款情况汇总表'
  }
},
{
  path: '/zcdsummary',
  name: 'zcdsummary',
  component: zcdsummary,
  meta: {
    title: '政采贷汇总表',
    isBlack: true
  }
},
{
  path: '/mpSjrSummary',
  name: 'mpSjrSummary',
  component: mpSjrSummary,
  meta: {
    title: '市场化产品贷款情况汇总表'
  }
},
{
  path: '/mpSjrOrderList',
  name: 'mpSjrOrderList',
  component: mpSjrOrderList,
  meta: {
    title: '市场化产品贷款情况列表'
  }
},
{
  path: '/mpSjrApplyDetail',
  name: 'mpSjrApplyDetail',
  component: mpSjrApplyDetail,
  meta: {
    title: '市场化产品贷款申请明细表'
  }
},
{
  path: '/mpSjrLoanDetail',
  name: 'mpSjrLoanDetail',
  component: mpSjrLoanDetail,
  meta: {
    title: '市场化产品放款明细表'
  }
},
{
  path: '/unPayOffTheLoanList',
  name: 'unPayOffTheLoanList',
  component: unPayOffTheLoanList,
  meta: {
    title: '到期未还款列表',
    isBlack: true
  }
},
{
  path: '/jrtj/loanprogressdetail',
  name: 'loanprogressdetail',
  component: PageLoanProgressDetail,
  meta: {
    title: '贷款流程明细表1'
  }
},
{
  path: '/jrtj/loanprogressdetailapplynumber',
  name: 'loanprogressdetailapplynumber',
  component: PageLoanProgressDetailApplynumber,
  meta: {
    title: '贷款申请次数',

  }
},
{
  path: '/jrtj/creditlist',
  name: 'creditlist',
  component: CreditList,
  meta: {
    title: '授信企业列表',

  }
},
{
  path: '/jrtj/loanprogressdetailcreditnumber',
  name: 'loanprogressdetailcreditnumber',
  component: PageLoanProgressDetailCreditnumber,
  meta: {
    title: '贷款流程明细表3'
  }
},
{
  path: '/jrtj/loanprogressdetailloannumber',
  name: 'loanprogressdetailloannumber',
  component: PageLoanProgressDetailLoannumber,
  meta: {
    title: '银行放款笔数',

  }
},

{
  path: '/companyList',
  name: 'companyList',
  component: companyList,
  meta: {
    title: '企业列表',
    isBlack: true
  }
},

{
  path: '/storageApply',
  name: 'storageApply',
  component: PageRuKu,
  meta: {
    title: '入库申请',
    isBlack: true
  }
},

{
  path: '/hndStorageApply',
  name: 'hndStorageApply',
  component: PageHndRuKu,
  meta: {
    title: '；惠农贷入库申请'
  }
},

{
  path: '/jrtj/pageCredit',
  name: 'pageCredit',
  component: PageCredit,
  meta: {
    title: '授信企业'
  }
},
{
  path: '/jrtj/pageLoaninfoDetail',
  name: 'PageLoaninfoDetail',
  component: PageLoaninfoDetail,
  meta: {
    title: '入库信息统计'
  }
},
{
  path: '/jrtj/pageBankLoanDetail',
  name: 'PageBankLoanDetail',
  component: PageBankLoanDetail,
  meta: {
    title: '银行放款信息（已放款(笔)）',

  }
},
{
  path: '/jrtj/pageAccpetanceEnterprise',
  name: 'pageAccpetanceEnterprise',
  component: pageAccpetanceEnterprise,
  meta: {
    title: '微票融操作企业数',

  }
},
{
  path: '/jrtj/pageAccpetanceNumber',
  name: 'pageAccpetanceNumber',
  component: pageAccpetanceNumber,
  meta: {
    title: '微票融操作笔数',

  }
},
{
  path: '/jrtj/searchXbcpLoan',
  name: 'searchXbcpLoan',
  component: searchXbcpLoan,
  meta: {
    title: '信保产品贷款情况汇总表',
    isBlack: true
  }
},
{
  path: '/jrtj/searchXbcpLoanXQ',
  name: 'searchXbcpLoanXQ',
  component: searchXbcpLoanXQ,
  meta: {
    title: '信保产品贷款情况汇总表',
    isBlack: true
  }
},
{
  path: '/jrtj/cxdStatistics',
  name: 'cxdStatistics',
  component: cxdStatistics,
  meta: {
    title: '创新贷统计',
    isBlack: true
  }
},
{
  path: '/XbjjTotalLoanData',
  name: 'XbjjTotalLoanData',
  component: XbjjTotalLoanData,
  meta: {
    title: '信保基金放款数据统计',
    isBlack: true
  }
},
{
  path: '/xbjjSituation',
  name: 'xbjjSituation',
  component: xbjjSituation,
  meta: {
    title: '信保基金运行情况'
  }
},
{
  path: '/cxdMDKList',
  name: 'cxdMDKList',
  component: cxdMDKList,
  meta: {
    title: '创新贷名单库单独管理页面',
    isBlack: true
  }
},
{
  path: '/cxdtxPage',
  name: 'cxdtxPage',
  component: cxdtxPage,
  meta: {
    title: '创新贷贴息',
    isBlack: true
  }
},
{
  path: '/cxdtxPageCS',
  name: 'cxdtxPageCS',
  component: cxdtxPageCS,
  meta: {
    title: '创新贷贴息(初审)',
    isBlack: true
  }
},
{
  path: '/cxdtxPageSH',
  name: 'cxdtxPageSH',
  component: cxdtxPageSH,
  meta: {
    title: '创新贷贴息(审核)',
    isBlack: true
  }
},
{
  path: '/cxdtxPageFH',
  name: 'cxdtxPageFH',
  component: cxdtxPageFH,
  meta: {
    title: '创新贷贴息(复核)',
    isBlack: true
  }
},
{
  path: '/cxdtxPageView',
  name: 'cxdtxPageView',
  component: cxdtxPageView,
  meta: {
    title: '创新贷贴息(已办)',
    isBlack: true
  }
},
{
  path: '/bankAssessment',
  name: 'bankAssessment',
  component: bankAssessment,
  meta: {
    title: '银行考核表',
    isBlack: true
  }
}
];
